module.exports = __webpack_public_path__ + "media/images/playbook_hiring_process-c09569370d214c63d2e8eced535ac811.svg";